/**
 * DxDy Site
 */

/* eslint-env browser */
"use strict";

import aos from "./vendor/aos";
import accordion from "./modules/accordion";
import nav from "./modules/nav";
import searchBar from "./modules/searchBar";
import scrollNav from "./modules/scrollNav";
import topicSlider from "./modules/topicSlider";
import filter from "./modules/filter";
import homeSlider from "./modules/homeSlider";
import worldMap from "./modules/worldMap";
import currencySelect from "./modules/currencySelect";
import attributableCosts from "./modules/attributableCosts";
import tooltip from "./modules/tooltip";
import "./modules/countrySelect";


(function () {
  aos.init();
  nav();
  searchBar();
  scrollNav();
  topicSlider();
  accordion();
  filter();
  worldMap();
  homeSlider();
  currencySelect();
  tooltip();
  attributableCosts();
})(jQuery);
